import React, { useEffect, useState } from "react";
import { useApolloClient } from '@apollo/react-hooks';
import { Loading } from "components/common";
import { UPDATE_MARKETING_CAMPAIGN } from 'utils/mutations';
import { CampaignsTable, RETRIEVE_MARKETING_CAMPAIGNS_QUERY } from "./marketingLanding";
import MarketingContainer from "./utils/components/MarketingContainer";
import MarketingNavigation from "./utils/components/MarketingNavigation";
import "./utils/styles/marketing-dashboard.css";

const MarketingV2Home = () => {
  const [campaigns, setCampaings] = useState();
  const [loadError, setLoadError] = useState();
  const [isLoading, setLoading] = useState(false);
  const client = useApolloClient();

  useEffect(() => {

    const loadCampaigns = async () => {
      try {
        setLoading(true);
        const { data } = await client.query({
          fetchPolicy: 'network-only',
          query: RETRIEVE_MARKETING_CAMPAIGNS_QUERY,
        });
        const { retrieveMarketingCampaign } = data;
        setCampaings(retrieveMarketingCampaign);
        setLoading(false);
      } catch (error) {
        setLoadError(error);
        setLoading(false);
      }
    };

    // if (!campaigns) {
    //   getCampaignsData();
    // }

    loadCampaigns();
  }, [client]);

  const handleModifyCampaign = async (row, status) => {
    try {
      setLoading(true);
      await client.mutate({
        mutation: UPDATE_MARKETING_CAMPAIGN,
        variables: {
          uuid: row.uuid,
          status,
        },
      });

      const idx = campaigns.findIndex((c) => c.uuid === row.uuid);
      campaigns[idx].status = status;
      setCampaings(campaigns);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoadError(error);
      setLoading(false);
    }
  };

  if (!campaigns || isLoading) { return (<Loading/>); }
  // if (loadError) { return someError messaging}

  return (
    <MarketingContainer>
      <MarketingNavigation />
      <CampaignsTable
        campaigns={campaigns}
        handleModifyState={handleModifyCampaign}
      />
    </MarketingContainer>
  );
};

export default MarketingV2Home;
